import { render, staticRenderFns } from "./quotation.vue?vue&type=template&id=b732650e&"
import script from "./quotation.vue?vue&type=script&lang=js&"
export * from "./quotation.vue?vue&type=script&lang=js&"
import style0 from "./quotation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports